import React from 'react';
import { useL10n } from '@uplift/hooks';
import { makeStyles } from 'tss-react/mui';
import { CreditCardValidator, MaskedInput, StandaloneAddressQuickSearchForm, TextInput, YesNoRadioButtonGroup } from '@uplift/ui-v2';
import { useFormikContext } from 'formik';
import { PaymentInfoFormType } from './validation';


export const PaymentInfoForm: React.VFC = () => {
  const l10n = useL10n();
  const { classes, cx } = usePaymentInfoFormStyles();
  const formik = useFormikContext<PaymentInfoFormType>();
  const secretFormControl = cx(classes.mb3, classes.formControl, 'fs-exclude');
  const formControl = cx(classes.mb3, classes.formControl);

  return (
    <div>
      <CreditCardValidator cardNumber={formik.values.cardNumber?.toString()} />
      <TextInput
        name="nameOnCard"
        label={l10n.matching.payment.nameOnCard}
        className={formControl}
        fullWidth
      />
      <MaskedInput
        fullWidth
        name="cardNumber"
        label={l10n.matching.payment.cardNumber}
        type="card"
        className={cx(secretFormControl, classes.creditCardBox)}
      />
      <MaskedInput
        type="cardExpiration"
        name="expirationDate"
        label={l10n.matching.payment.expDate}
        className={cx(secretFormControl, classes.width120)}
        helperText="MM/YY"
      />
      <MaskedInput
        type="cvc"
        name="cvc"
        label={l10n.matching.payment.cvc}
        className={cx(secretFormControl, classes.width120)}
        showPlaceholder={false}
      />
      <YesNoRadioButtonGroup
        label="My billing and home address are the same"
        name="billingAndHomeAddressSame"
        className={secretFormControl}
        asBoolean
      />
      {formik.values.billingAndHomeAddressSame === false && (
        <StandaloneAddressQuickSearchForm
          label={l10n.matching.payment.billingAddress}
          getFieldName={(name) => `address.${name}`}
        />
      )}
    </div>
  );
};

const usePaymentInfoFormStyles = makeStyles({ name: 'PaymentInfoForm' })(theme => ({
  formControl: {
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '75%',
    },
  },
  creditCardBox: {
    display: 'block',
    width: '220px',
    [theme.breakpoints.up('sm')]: {
      width: '220px',
    },
  },
  width120: {
    display: 'block',
    width: '120px',
    [theme.breakpoints.up('sm')]: {
      width: '120px',
    },
  },
  mb3: {
    marginBottom: theme.spacing(3),
  },
}));
